/**
 * @file CatalogScreenStructure.tsx
 * @description Структура экрана «Каталог» (phase19.16 Р2а; uiux-design-r2a
 * §2, §6; SB31): Шапка · [Над списком] · «Список товаров — вид в панели
 * «Каталог»» (замок) · [Под списком] · Подвал. Блоки мест над и под списком
 * — одни для каталога и всех категорий; правки идут в черновик места и
 * попадают на сайт после «Опубликовать» (Р3а, SB126), вид списка и карточки —
 * после публикации вида сайта.
 */

import { siteSlotsFor } from "@chaiberi/shared";

import { useBuilder } from "../builder-context";
import { AreaRow } from "./AreaRow";
import { LockedScreenRow } from "./LockedScreenRow";
import { SlotGroup } from "./SlotGroup";
import { useScreenSlots } from "../../../hooks/site-builder/useScreenSlots";

/** Подсказки пустых мест (uiux-design-r2a §6). */
const EMPTY_TEXT: Readonly<Record<string, string>> = {
  CATALOG_ABOVE: "Пусто — добавьте акции, подборку или текст над товарами.",
  CATALOG_BELOW: "Пусто — сюда подойдут вопросы и ответы или условия доставки.",
};

export function CatalogScreenStructure() {
  const b = useBuilder();
  const api = useScreenSlots(b.canEditPages);
  const [above, below] = siteSlotsFor("catalog");
  const area = b.selection.sel.kind === "area" ? b.selection.sel.area : null;
  return (
    <div className="flex flex-col gap-1">
      <AreaRow area="header" selected={area === "header"} />
      {api.error ? <p className="type-caption px-3 text-on-surface-variant">Не удалось загрузить блоки каталога — проверьте связь.</p> : null}
      {above ? <SlotGroup slotKey={above.key} api={api} emptyText={EMPTY_TEXT[above.key]} /> : null}
      <LockedScreenRow label="Список товаров — вид в панели «Каталог»" onOpen={() => void b.select({ panel: "catalog", sub: null })} />
      {below ? <SlotGroup slotKey={below.key} api={api} emptyText={EMPTY_TEXT[below.key]} /> : null}
      <AreaRow area="footer" selected={area === "footer"} />
      <p className="type-caption px-3 pt-2 text-on-surface-variant">Блоки над и под списком — одни для каталога и всех категорий. Правки — в черновике, на сайте после «Опубликовать».</p>
    </div>
  );
}
